import { Fragment, useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import { MdRefresh } from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../../../function/helper";
import useTipax from "../../../../../hooks/tipax/useTipax";
import getAddressOrderShipement from "../../hooks/address/getAddressOrderShipement";
import useChaparRate from "../../hooks/chaparApi/useChaparRate";
import useMahexRate from "../../hooks/mahexApi/useMahexRate";
import usePostRate from "../../hooks/postApi/usePostRate";
import style from "./PostServiceList.module.css";
import useDekapost from "../../../../../hooks/dekapost/useDekapost";
import useSharedData from "../../../../../hooks/useSharedData";

function PostServiceList({ companies, rowsData, close, isCod, detail }) {
  const { sender: SAddress, getter: RAddress } = getAddressOrderShipement();

  const navigate = useNavigate();

  const { isAgent } = useSharedData();

  const postRate = usePostRate;
  const mahexRate = useMahexRate;
  const chaparRate = useChaparRate;
  const { tipaxRate } = useTipax();
  const { dekapostRate } = useDekapost();

  const [selectedService, setSelectedService] = useState(null);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [finalServiceList, setFinalServiceList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [rateModal, setRateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(true);

  const [sms, setSms] = useState(false);
  const [print, setPrint] = useState(isAgent);
  const [needCollecting, setNeedCollecting] = useState(true);

  const chooseServiceType = () => {
    if (selectedService?.chaparData?.quote > 0) {
      sendRequest();
    } else {
      Swal.fire({
        icon: "error",
        text: "نوع سرویس را انتخاب نکرده اید",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  const getData = async () => {
    setIsFetchingData(true);

    const list = [
      chaparRate({
        SAddress: SAddress,
        RAddress: RAddress,
        chaparType: companies[0],
        rowsData: rowsData,
        totalCost: detail.totalCost,
        totalWeightPayable: detail.totalWeightPayable,
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        isCod,
        needCollecting,
      }),
      chaparRate({
        SAddress: SAddress,
        RAddress: RAddress,
        chaparType: companies[1],
        rowsData: rowsData,
        totalCost: detail.totalCost,
        totalWeightPayable: detail.totalWeightPayable,
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        isCod,
        needCollecting,
      }),
      postRate({
        SAddress: SAddress,
        RAddress: RAddress,
        postItem: companies[3],
        totalCost: detail.totalCost,
        totalWeightPayable: detail.totalWeightPayable,
        rowsData: rowsData,
        serviceTypeId: companies[3].compony_type_post.chaparId,
        methodPayment: isCod ? 0 : 1,
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        isCod,
        needCollecting,
      }),
      postRate({
        SAddress: SAddress,
        RAddress: RAddress,
        postItem: companies[5],
        totalCost: detail.totalCost,
        totalWeightPayable: detail.totalWeightPayable,
        rowsData: rowsData,
        serviceTypeId: companies[5].compony_type_post.chaparId,
        methodPayment: isCod ? 0 : 1,
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        isCod,
        needCollecting,
      }),

      // پست اکسپرس فعلا غیر فعال می‌باشد
      /*
      postRate({
        SAddress: SAddress,
        RAddress: RAddress,
        postItem: companies[12],
        totalCost: detail.totalCost,
        totalWeightPayable: detail.totalWeightPayable,
        rowsData: rowsData,
        serviceTypeId: companies[12].compony_type_post.chaparId,
        methodPayment: isCod ? 0 : 1,
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        isCod,
        needCollecting,
      }),
      */

      tipaxRate({
        senderAddressId: SAddress?.id,
        getterAddressId: RAddress?.id,
        shipments: rowsData,
        isCod,
        isBulk: false,
        postItem: companies[9],
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        needCollecting,
      }),
      /*
      // آواپیما موقتا تعطیل می‌باشد
      avaPeymaRate({
        SAddress: SAddress,
        RAddress: RAddress,
        shipments: rowsData,
        isCod,
        isBulk: false,
        postItem: companies[10],
        totalSpecialService: detail.totalSpecialService,
        needSMS: sms,
        needPrint: print,
        needCollecting,
      }),
      */
      dekapostRate({
        senderAddressId: SAddress?.id,
        getterAddressId: RAddress?.id,
        parcels: rowsData,
        isCod,
        postItem: companies[13],
        companyTypeId: companies[13].componyTypeId,
        needSMS: sms,
        needPrint: print,
        needCollecting,
      }),
    ];

    if (isCod === false) {
      list.push(
        mahexRate({
          SAddress: SAddress,
          RAddress: RAddress,
          mahexType: companies[2],
          totalCost: detail.totalCost,
          totalWeightPayable: detail.totalWeightPayable,
          rowsData: rowsData,
          totalSpecialService: detail.totalSpecialService,
          needSMS: sms,
          needPrint: print,
          needCollecting,
        })
      );
    }

    const response = await Promise.all(list);
    const result = response.filter(item => item.chaparData.quote !== 0);
    result.sort(compare);

    setIsFetchingData(false);
    setFinalServiceList(result);
  };

  const compare = (a, b) => {
    if (a.chaparData.totalPrice < b.chaparData.totalPrice) {
      return -1;
    }
    if (a.chaparData.totalPrice > b.chaparData.totalPrice) {
      return 1;
    }
    return 0;
  };

  const sendRequest = async () => {
    if (selectedService.Data.componyId === 1) {
      for (
        let i = 0;
        i < selectedService.chaparData.pishtazKerayeArrayPrice.length;
        i++
      ) {
        rowsData[i].price =
          selectedService.chaparData.pishtazKerayeArrayPrice[i];
      }
    }

    if (selectedService.Data.componyId === 3) {
      for (let i = 0; i < selectedService.chaparData.arrayPrice.length; i++) {
        rowsData[i].price = selectedService.chaparData.arrayPrice[i];
      }
    }

    if (selectedService.Data.componyId === 9) {
      for (let i = 0; i < selectedService.chaparData.prices.length; i++) {
        rowsData[i].price = selectedService.chaparData.prices[i];
      }
    }

    setLoading(true);
    const body = {
      addressId: SAddress.id,
      getterAddressId: RAddress.id,
      componyId: selectedService.Data.componyId,
      componyTypeId: selectedService.Data.componyTypeId,
      componyServicesId: selectedService.Data.id,
      price: selectedService.chaparData.quote,
      printFactor: print,
      hasNotifRequest: sms,
      data: rowsData,
      totalNumber: detail.totalNumber,
      totalCollectiveWeight: detail.totalCollectiveWeight,
      totalGrossWeight: detail.totalGrossWeight,
      totalWeightPayable: detail.totalWeightPayable,
      totalCost: detail.totalCost,
      totalSpecialService: detail.totalSpecialService,
      isCod,
      needCollecting,
      collectingType: 1,
      bankAccountId: detail.bankAccountId,
    };
    const response = await postRequestByAuth("/internalpost/v1/add2", body);

    if (response && response.status === 200) {
      navigate(`/prefactor/${response.data.data}`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        text: response.data.data,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  return (
    <Fragment>
      <Modal show={rateModal} centered direction="rtl" size="xl">
        <Modal.Header className="d-flex align-item-center justify-content-center">
          <Modal.Title>لیست سرویس های پستی برای این مرسوله</Modal.Title>
          <button
            className="btn btn-outline-primary"
            onClick={getData}
            style={{ marginRight: "80px" }}
          >
            استعلام مجدد
            <MdRefresh style={{ height: 30, width: 30 }} />
          </button>
        </Modal.Header>
        <Modal.Body
          className="d-flex align-item-center justify-content-center text-right "
          style={{ textAlign: "right", direction: "rtl" }}
        >
          <div className="w-100">
            {isFetchingData ? (
              <>
                <p style={{ fontSize: 20 }}>در حال استعلام قیمت</p>
                <Skeleton
                  count={4}
                  height={50}
                  baseColor="#b0bab5"
                  direction="rtl"
                  duration={2}
                />
              </>
            ) : (
              <>
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th></th>
                      <th className="text-secondary">سرویس دهنده</th>
                      <th className="text-secondary">نام سرویس دهنده</th>
                      <th className="text-secondary">نوع سرویس</th>
                      <th className="text-secondary">مدت زمان ارسال</th>
                      <th className="text-secondary">قیمت بارکد پستی</th>
                      <th className="text-secondary">قیمت نهایی</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {finalServiceList.map((item, indx) => (
                      <tr key={indx}>
                        <td className="align-middle">
                          <Form.Check
                            type="radio"
                            name="selectedService"
                            value={item}
                            size="lg"
                            className="d-inline-block mx-1 selectedService"
                            onClick={() => setSelectedService(item)}
                          />
                        </td>
                        <td>
                          <img
                            src={item.Data.compony.image}
                            width={item.Data.componyId === 1 ? 50 : 80}
                            className="d-inline-block"
                          />
                        </td>
                        <td>{item.Data.compony.name}</td>
                        <td>{item.chaparData.method_name}</td>
                        {item.chaparData.method_name === "ویژه" &&
                          item.Data.componyId === 1 && <td> ۳۶ تا 72 ساعت</td>}
                        {item.Data.componyId === 1 &&
                          item.chaparData.method_name === "پیشتاز" && (
                            <td>3 تا 9 روز </td>
                          )}
                        {item.Data.componyId === 1 &&
                          item.chaparData.method_name === "اکسپرس" && (
                            <td> 24 تا 72 ساعت</td>
                          )}
                        {item.Data.componyId !== 1 && <td> 24 تا 72 ساعت</td>}

                        <td>
                          <span>{item.chaparData.quote.toLocaleString()}</span>
                          <span style={{ fontSize: 12 }}> ریال</span>
                        </td>

                        <td style={{ minWidth: 180 }}>
                          <span className="fw-bold fs-5">
                            {item.chaparData?.totalPrice?.toLocaleString()}
                          </span>
                          <span style={{ fontSize: 12 }}> ریال</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
            <Modal.Footer className="d-flex align-item-center justify-content-center">
              <Row className="">
                <Col xs={8} sm={8} md={8} lg={8}>
                  {loading === true && (
                    <button type="button" className="btn-success-style mx-1">
                      <div className="d-flex align-items-center">
                        <Spinner
                          style={{
                            width: "20px",
                            height: "20px",
                            fontSize: "0.8rem",
                          }}
                        />
                        <span className="me-3"> در حال اجرا</span>
                      </div>
                    </button>
                  )}
                  {loading === false && (
                    <Button
                      className="btn-success-style"
                      onClick={chooseServiceType}
                    >
                      تائید
                    </Button>
                  )}
                </Col>
                <Col xs={4} sm={4} md={4} lg={4}>
                  <Button
                    className="btn-cancel-style"
                    onClick={close}
                    disabled={loading}
                  >
                    انصراف
                  </Button>
                </Col>
              </Row>
            </Modal.Footer>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={confirmModal} centered direction="rtl">
        <Modal.Header className="d-flex align-item-center justify-content-center">
          <Modal.Title>لطفا موارد زیر را مشخص نمایید</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="d-flex align-item-center justify-content-center text-right "
          style={{ textAlign: "right", direction: "rtl" }}
        >
          <div className="w-100">
            <Row>
              {!isAgent && (
                <Form.Group className={style.checkBox}>
                  <Form.Check
                    type="checkbox"
                    checked={needCollecting}
                    id="ertaw35qe6r56a"
                    onChange={e => setNeedCollecting(e.target.checked)}
                  />
                  <Form.Label
                    htmlFor="ertaw35qe6r56a"
                    className="c-pointer user-select-none"
                  >
                    نیاز به جمع آوری دارم
                  </Form.Label>
                </Form.Group>
              )}

              <Form.Group className={style.checkBox}>
                <Form.Check
                  type="checkbox"
                  value={sms}
                  id="wieorada543a"
                  onChange={e => setSms(e.target.checked)}
                />
                <Form.Label
                  htmlFor="wieorada543a"
                  className="c-pointer user-select-none"
                >
                  درخواست دریافت پیامک در مراحل ارسال را دارم.
                </Form.Label>
              </Form.Group>

              {isAgent === false && (
                <Fragment>
                  <Form.Group className={style.checkBox}>
                    <Form.Check
                      type="checkbox"
                      id="serweoirw7a78"
                      value={print}
                      onClick={e => setPrint(e.target.checked)}
                    />
                    <Form.Label
                      htmlFor="serweoirw7a78"
                      className="c-pointer user-select-none"
                    >
                      نیاز به پرینت فاکتور توسط نمایده سامانه آواکس دارم:
                    </Form.Label>
                  </Form.Group>
                  <div className="w-100">
                    <ul>
                      <li>
                        چنانچه امکان پرینت فاکتور را ندارید، آدرس دقیق فرستنده و
                        گیرنده را بصورت واضح و خوانا بر روی بسته پستی خود درج
                        نمایید.
                      </li>
                      <li>
                        چنانچه امکان پرینت فاکتور را دارید، از فاکتور خود در دو
                        نسخه پرینت تهیه کرده ، یک فاکتور را بر روی بسته خود
                        بچسبانید بصورتی که تا تحویل مرسوله از آن جدا نشود و در
                        فاکتور دوم از جمع آور امضا گرفته و نزد خود نگه دارید.
                      </li>
                    </ul>
                  </div>
                </Fragment>
              )}
            </Row>
            <Modal.Footer className="d-flex align-item-center justify-content-center">
              <div className="mx-2 px-2 d-flex align-items-center">
                {loading === false && (
                  <button
                    className="btn-success-style mx-1"
                    onClick={() => {
                      setConfirmModal(false);
                      setRateModal(true);
                      getData();
                    }}
                  >
                    بعدی
                  </button>
                )}

                <button
                  className="btn-cancel-style mx-1"
                  disabled={loading === true}
                  onClick={() => {
                    setConfirmModal(false);
                    close();
                  }}
                >
                  انصراف
                </button>
              </div>
            </Modal.Footer>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default PostServiceList;
